package com.evoapps.evoshift.widgets

import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.evoapps.evoshift.ui.util.UiText
import com.evoapps.evoshift.ui.util.asString

/**
 * SH-188: shows [message] in the snackbar, then tells the view model it was shown ([onShown]
 * clears it). Clearing after the snackbar, not before, keeps the snackbar on screen: the effect
 * restarts on the cleared (null) text and does nothing. Because the message is cleared, the same
 * text set again (the second failure in a row, say) shows again, which a `LaunchedEffect` keyed
 * on a message that is never cleared does not.
 */
@Composable
fun MessageEffect(
    message: UiText?,
    snackbarHostState: SnackbarHostState,
    onShown: () -> Unit,
    duration: SnackbarDuration = SnackbarDuration.Short
) {
    val text = message?.asString()
    LaunchedEffect(text) {
        if (text == null) return@LaunchedEffect
        snackbarHostState.showSnackbar(text, duration = duration)
        onShown()
    }
}
